import TaskHeader from "components/task/header/TaskHeader";
import { Box } from "@mui/joy";
import useSubscriptionStatus from "hooks/useSubscriptionStatus";
import MyValueCompassContent from "./MyValueCompassContent";
import NoticeBannerStatic from "../../common/NoticeBannerStatic";

export default function MyValueCompass({
  showPaymentModule,
}: {
  showPaymentModule: boolean;
}) {
  const { isNotStarted } = useSubscriptionStatus();

  return (
    <>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 100,
        }}
      >
        <TaskHeader taskKey={"valueCompass"} />
        <NoticeBannerStatic
          message={"프로그램이 진행되며 자동으로 완성됩니다."}
          type={"valueCompass"}
        />
      </Box>

      <div className="w-full h-full overflow-x-hidden">
        <MyValueCompassContent />
      </div>
    </>
  );
}
